import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import TaxonomyThemePageChild from './Child';
import TaxonomyThemePageParent from './Parent';

export interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemePage: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const parent = theme.parent[0]?.target_id;

  // If the taxonomy has a parent, it must be a child.
  if (parent) {
    return <TaxonomyThemePageChild entity={entity} />;
  }

  // If the taxonomy has no parent, itself must be a parent.
  return <TaxonomyThemePageParent entity={entity} />;
};

export default TaxonomyThemePage;
